export const PDF_PRINTING_FILE_CLOUD_FRONT_HOST = '7dnmuzhtu9q7u9sbdyuf.cf.marpple.com';
